import { Heading } from 'spa/components/typography'
import { Logo } from 'spa/components/logo'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import styles from './styles'
import React from 'react'

const SunsetHeader = ({ intl }) => {
  return (
    <div className={styles.header}>
      <Logo forceDarkMode />
      <div className={styles.headingContainer}>
        <Heading className={styles.heading}>
          <FormattedMessage
            id="djcity.common.sunset.header.title"
            defaultMessage="Now on Beatport"
          />
        </Heading>
        <a
          className={styles.learnMoreLink}
          target="_blank"
          href={intl.formatMessage({
            id: 'djcity.common.sunset.header.subtitle.link',
            defaultMessage: '/',
          })}
        >
          <FormattedMessage
            id="djcity.common.sunset.header.subtitle"
            defaultMessage="Learn more"
          />
        </a>
      </div>
    </div>
  )
}

SunsetHeader.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(SunsetHeader)
